import { defineClientComponent } from './src/js/clientComponents.ts';
import Component from './src/pages/sanity/page/ListPage/index.tsx';
defineClientComponent('sanity/page/ListPage/index', Component);